/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Blocked_Store_BodyInputs */

const en_premium_blocked_store_body = /** @type {(inputs: Premium_Blocked_Store_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription is billed through the App Store or Google Play. Manage it there — buying again here would charge you twice.`)
};

const es_premium_blocked_store_body = /** @type {(inputs: Premium_Blocked_Store_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu suscripción se cobra a través de App Store o Google Play. Adminístrala allí: comprar de nuevo aquí te cobraría dos veces.`)
};

/**
* | output |
* | --- |
* | "Your subscription is billed through the App Store or Google Play. Manage it there — buying again here would charge you twice." |
*
* @param {Premium_Blocked_Store_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_blocked_store_body = /** @type {((inputs?: Premium_Blocked_Store_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Blocked_Store_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_blocked_store_body(inputs)
	return en_premium_blocked_store_body(inputs)
});